module.exports = __webpack_public_path__ + "static/media/tidal.2e1f21c8.svg";